import actions from "./actions.js";
import mutations from "./mutations.js";

export const initialState = () => {
  return {
    isSelectionContinuous: false,
    isSelectionPicksOnly: false,
    isSelectionDrivesOnly: false,
    isSelectionOneTypeOnly: false,
    selectionLength: 0
  };
};

export const selectionModule = {
  state: initialState(),
  namespaced: true,
  actions,
  mutations
};
